import React from 'react';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import messages from './messages';
import {WithUser} from 'api/users/withMe';
import {isCookiePolicyAccepted, setCookiePolicyAccepted} from './helpers';


const COOKIE_POLICY_URL = 'https://alvalabs.io/cookie-policy';


class CookieBanner extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            cookieAccepted: isCookiePolicyAccepted()
        };
    }

    setCookieAccepted = () => {
        this.setState({cookieAccepted: true}, setCookiePolicyAccepted);
    };

    onQueryCompleted = (data) => {
        // Is user actually exist => user exist => cookie policy is accepted by EULA
        if (data.me) {
            if (!this.state.cookieAccepted) {
                this.setCookieAccepted();
            }
        }
    };

    render() {

        return (
            <WithUser onCompleted={this.onQueryCompleted}>
                {({loading, user}) => {
                    if (loading) {
                        return null;
                    }

                    if (user) {
                        return null;
                    }

                    if (this.state.cookieAccepted) {
                        return null;
                    }

                    return (
                        <Wrapper>
                            <div className="columns">
                                <div className="column is-6">
                                    <FormattedMessage {...messages.description}/>
                                </div>
                                <div className="column is-6">
                                    <ReadMoreButton className="button is-small" href={COOKIE_POLICY_URL} target="_blank">
                                        <FormattedMessage {...messages.readMore}/>
                                    </ReadMoreButton>
                                    <AcceptButton className="button is-small" onClick={this.setCookieAccepted}>
                                        <FormattedMessage {...messages.accept}/>
                                    </AcceptButton>
                                </div>
                            </div>
                        </Wrapper>
                    );
                }}
            </WithUser>
        );
    }
}

const Wrapper = styled.div`
    background-color: #2b353e;
    border-bottom: 1px solid #171515;
    color: #fff;
    text-align: center;
    padding: 20px 32px;   
    position: fixed;
    border-radius: 2px;
    bottom: 0;
    left: 140px;
    right: 140px;
    z-index: 999;
    @media (max-width: 1024px) {
        padding: 16px 12px;
        left: 0;
        right: 0;
    }
`;

const Button = styled.a`
    border-radius: 2px;
    cursor: pointer;
    font-size: .75rem;
    text-align: center;
    margin: 0 16px;
    padding: 0 16px;    
    display: inline-block;
    line-height: 28px;
    height: 30px;
`;

const ReadMoreButton = styled(Button)`
    background-color: #fff;
    border-color: #dbdbdb;
    color: #363636;
`;

const AcceptButton = styled(Button)`
    background-color: #fff;
    border-color: #dbdbdb;
    color: #363636;
`;

export default CookieBanner;
